// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../styles/fonts/creato_display/CreatoDisplay-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../styles/fonts/creato_display/CreatoDisplay-BlackItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../styles/fonts/creato_display/CreatoDisplay-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../styles/fonts/creato_display/CreatoDisplay-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../styles/fonts/creato_display/CreatoDisplay-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../styles/fonts/creato_display/CreatoDisplay-ExtraBoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../styles/fonts/creato_display/CreatoDisplay-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../styles/fonts/creato_display/CreatoDisplay-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../styles/fonts/creato_display/CreatoDisplay-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../styles/fonts/creato_display/CreatoDisplay-MediumItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../styles/fonts/creato_display/CreatoDisplay-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../styles/fonts/creato_display/CreatoDisplay-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../styles/fonts/creato_display/CreatoDisplay-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../styles/fonts/creato_display/CreatoDisplay-ThinItalic.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'CreatoDisplay';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
  font-weight: 100;
  font-style: italic;
}

/* Configuración global */
body {
font-family: "CreatoDisplay", sans-serif;
margin: 0;
padding: 0;
box-sizing: border-box;
}
.container  {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}


html, body {
  width: 100%;
  height: 100%;
}

#root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #000; 
  overflow: hidden;
}

.hero img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}
::-webkit-scrollbar {
  width: 0px; 
  height: 0px; 
}


.scrollable-container {
  overflow-y: scroll; 
  height: 100vh;      

}


header img {
  height: 40px;
}

section {
  padding: 20px;
}

footer {
  background-color: #ffffff;
  color: #000000;
  padding: 10px;
  width: 99%;
  font-weight: bold;
  position: relative;
  bottom: 0;
}

footer a {
  color: #000000;
  margin-right: 10px;
  text-decoration: none;
}

footer a:hover {
  color: #808080;
}

footer p {
  margin: 0;
}

@media (max-width: 768px) {
  .container {
    padding: 0 10px;
  }

  section {
    flex-direction: column;
    padding: 10px;
  }

  section img {
    width: 100%;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,+DAAqF;EACrF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA2F;EAC3F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAoF;EACpF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA0F;EAC1F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAyF;EACzF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA+F;EAC/F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAqF;EACrF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA2F;EAC3F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAAsF;EACtF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA4F;EAC5F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gEAAuF;EACvF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gEAA6F;EAC7F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gEAAoF;EACpF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gEAA0F;EAC1F,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;AACA,wCAAwC;AACxC,SAAS;AACT,UAAU;AACV,sBAAsB;AACtB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,aAAa;;AAEf;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;AAEF","sourcesContent":["@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-Black.otf') format('opentype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-BlackItalic.otf') format('opentype');\n  font-weight: 900;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-Bold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-BoldItalic.otf') format('opentype');\n  font-weight: 700;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-ExtraBold.otf') format('opentype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-ExtraBoldItalic.otf') format('opentype');\n  font-weight: 800;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-Light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-LightItalic.otf') format('opentype');\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-MediumItalic.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-Regular.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-RegularItalic.otf') format('opentype');\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-Thin.otf') format('opentype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'CreatoDisplay';\n  src: url('../styles/fonts/creato_display/CreatoDisplay-ThinItalic.otf') format('opentype');\n  font-weight: 100;\n  font-style: italic;\n}\n\n/* Configuración global */\nbody {\nfont-family: \"CreatoDisplay\", sans-serif;\nmargin: 0;\npadding: 0;\nbox-sizing: border-box;\n}\n.container  {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n\n\nhtml, body {\n  width: 100%;\n  height: 100%;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.hero {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000; \n  overflow: hidden;\n}\n\n.hero img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n}\n::-webkit-scrollbar {\n  width: 0px; \n  height: 0px; \n}\n\n\n.scrollable-container {\n  overflow-y: scroll; \n  height: 100vh;      \n\n}\n\n\nheader img {\n  height: 40px;\n}\n\nsection {\n  padding: 20px;\n}\n\nfooter {\n  background-color: #ffffff;\n  color: #000000;\n  padding: 10px;\n  width: 99%;\n  font-weight: bold;\n  position: relative;\n  bottom: 0;\n}\n\nfooter a {\n  color: #000000;\n  margin-right: 10px;\n  text-decoration: none;\n}\n\nfooter a:hover {\n  color: #808080;\n}\n\nfooter p {\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 0 10px;\n  }\n\n  section {\n    flex-direction: column;\n    padding: 10px;\n  }\n\n  section img {\n    width: 100%;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
